import type { ReactNode } from 'react';

export const symbol_reset_shutter_speed: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M480-280q0-45 18.5-83t49.5-66l86 149H480Zm100 172q-37-21-62-55t-34-77h173l-77 132Zm77-212-77-132q23-13 48-20.5t52-7.5q17 0 32.5 3t30.5 8l-86 149Zm23 240q-17 0-32.5-3T617-91l86-149 77 132q-23 13-48 20.5T680-80Zm23-240 77-132q37 21 62 55t34 77H703Zm109 189-86-149h154q0 45-18 83t-50 66ZM480-780q-125 0-212.5 87.5T180-480q0 81 38.5 147.5T320-226v-84q0-13 8.5-21.5T350-340q13 0 21.5 8.5T380-310v160q0 13-8.5 21.5T350-120H190q-13 0-21.5-8.5T160-150q0-13 8.5-21.5T190-180h91q-73-48-117-127t-44-173q0-75 28.5-140.5t77-114q48.5-48.5 114-77T480-840q123 0 216.5 72.5T824-583q4 12-2 22.5T804-546q-12 4-23-2t-15-18q-29-92-107-153t-179-61Z"
		/>
	</svg>
);
